import React from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { DialogOpenType, openDialog } from "state/slices/DialogSlice";
import { useTypedDispatch, useTypedSelector } from "hooks/store";
import { useHistory } from "react-router-dom";
import RoutesName from "routes/routesName";
import { builder } from "Classes/global";
import { useCmrAuth } from "state/CMRAuth";
import { setPatientLocked } from "state/slices/SceneSlice";

type ComponentProps = {
    title: string;
};

const DialogDefaultContent = ({ title }: ComponentProps): JSX.Element => {
    const dispatch = useTypedDispatch();
    const cmrAuth = useCmrAuth();
    const type = useTypedSelector((store) => store.Dialog.type);
    const currentScene = useTypedSelector((store) => store.Scene.currentScene);
    const router = useHistory();

    const handleDialogClose = () => {
        switch (type) {
            case DialogOpenType.Logout:
                cmrAuth.signOut();
                break;
            case DialogOpenType.NewSetup:
                builder.clearAll();
                router.push({ pathname: RoutesName.newSetup });
                break;
            case DialogOpenType.LoadSetup:
                builder.clearAll();
                router.push({ pathname: RoutesName.preset });
                break;
            case DialogOpenType.Import:
                builder.clearAll();
                router.push({ pathname: RoutesName.import });
                break;
            case DialogOpenType.ResetRoom:
                builder.reset(currentScene);
                dispatch(setPatientLocked(false));
                break;
        }
        dispatch(openDialog({ isDialogOpen: false, type }));
    };
    const handleCancelDialog = () => {
        dispatch(openDialog({ isDialogOpen: false, type }));
    };

    return (
        <>
            <DialogContent>
                <DialogContentText
                    className="cmrDialogDescription"
                    style={{ marginBottom: "1rem" }}
                >
                    {title}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="cmrDialogActionContainer">
                <Button
                    startIcon={<CloseOutlinedIcon />}
                    fullWidth
                    onClick={handleCancelDialog}
                    className="btn grayRoundedButton"
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleDialogClose}
                    fullWidth
                    startIcon={<CheckOutlinedIcon />}
                    className="btn pinkRoundedButton"
                >
                    Confirm
                </Button>
            </DialogActions>
        </>
    );
};

export default DialogDefaultContent;
